/* eslint-disable no-unused-vars */

import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/records`;

const state = {
    route_requests: [],
    approved_requests: [],
    rejected_requests: [],
}

const getters = {
    getRouteRequests: state => state.route_requests,
    getApprovedRequests: state => state.approved_requests,
    getRejectedRequests: state => state.rejected_requests
}

const actions = {
    async fetchRouteRequests({ commit }) {
        try {

            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/requests`, { headers: { 'x-drmms-token': authToken } });

            let pending = [];
            let approved = [];
            let rejected = [];

            response.data.forEach(element => {
                let request = element;

                request = Object.assign(request, {
                    initiator_name: request.isInitiatorRoute ?
                        `${request.route.user.first_name} ${request.route.user.last_name}` :
                        `${request.user_route_assignment.route.user.first_name} ${request.user_route_assignment.route.user.last_name}`,
                    action_subject: request.isInitiatorRoute ?
                        request.route.subject :
                        request.user_route_assignment.action.name,
                    route_type: request.isInitiatorRoute ? 'Initiator' : 'Sub-Route',
                    user_assigned: request.isInitiatorRoute ?
                        `${request.route.user.first_name} ${request.route.user.last_name}` :
                        `${request.user_route_assignment.user.first_name} ${request.user_route_assignment.user.last_name}`,
                    dateRequested: moment(request.createdAt).format('LLL')
                });

                switch (request.status) {
                    case 'Pending': {
                        pending.push(request);
                        break;
                    }
                    case 'Approved': {
                        approved.push(request);
                        break;
                    }
                    case 'Rejected': {
                        rejected.push(request);
                        break;
                    }
                }
            })

            let mutationObject = { pending, approved, rejected }

            commit('setRouteRecordRequests', mutationObject);

        } catch (err) {
            console.log(err);
        }
    },
    async sendRouteRequest({ commit }, body) {
        try {

            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(`${url}/requests`, body, { headers: { 'x-drmms-token': authToken } });

            return response.data;

        } catch (err) {
            console.log(err);
        }
    },
    async attachRouteRecords({ commit }, body) {
        let { type, route_id, records, remarks, request_id } = body;

        let tempUrl = `${apiServerUrl}/routes`;
        let customUrl = (type == 'mainroute') ? `${tempUrl}/route/records/attach/${route_id}` : `${tempUrl}/subroute/records/attach/${route_id}`;

        let record_ids = [];

        try {
            records.forEach(element => { record_ids.push(element.id) });

            const authToken = localStorage.getItem('access_token');
            await axios.post(customUrl, { record_ids, remarks, request_id }, { headers: { 'x-drmms-token': authToken } });

            commit('approvePendingRequest', request_id);
            return true;

        } catch (err) {
            console.log(err);
        }
    },
    async rejectRouteRequest({ commit }, body) {
        try {

            const { request_id, remarks } = body;

            const authToken = localStorage.getItem('access_token');

            const response = await axios({
                url: `${url}/requests/${request_id}`,
                method: 'put',
                data: { remarks },
                headers: { 'x-drmms-token': authToken }
            })

            commit('setRejectedRequest', request_id);
            return true;

        } catch (err) {
            console.log(err);
        }
    },
    async fetchRecordRequestsList({ commit }, body) {
        
    }
}

const mutations = {
    setRouteRecordRequests: (state, requests) => {
        const { pending, approved, rejected } = requests;

        state.route_requests = pending;
        state.approved_requests = approved;
        state.rejected_requests = rejected;
    },
    approvePendingRequest: (state, request_id) => {
        const index = state.route_requests.findIndex((r) => r.id == request_id);

        if (index !== -1) {
            let selectedRequest = state.route_requests[index];
            selectedRequest.status = 'Approved';

            state.approved_requests.push(selectedRequest);

            let newStateReqeusts = state.route_requests.filter((r) => r.id != request_id);
            state.route_requests = newStateReqeusts;
        }
    },
    setRejectedRequest: (state, request_id) => {
        const index = state.route_requests.findIndex((r) => r.id == request_id);

        if (index !== -1) {
            let selectedRequest = state.route_requests[index];
            selectedRequest.status = 'Rejected';

            state.rejected_requests.push(selectedRequest);

            let newStateReqeusts = state.route_requests.filter((r) => r.id != request_id);
            state.route_requests = newStateReqeusts;
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}